import { gql } from '@apollo/client';

export const SEARCH_ARTICLES = gql`
  query SearchArticles(
    $where: ArticleFilterSearchInput
    $first: UnsignedInt!
    $skip: UnsignedInt
    $orderBy: [ArticleOrderingSearchInput!]
  ) {
    searchArticles(
      first: $first
      where: $where
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      title
      brandKey
      body
      medias
      publishedAt
      status
      creator {
        name
      }
      canonical
    }
  }
`;
